import '@leanpay/ui/main.css'

import React, { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router-dom'

import type { AnalyticsContext } from '@leanpay/analytics'
import { LeanPayAnalyticsProvider } from '@leanpay/analytics'
import { announceStoredGoogleConsent } from '@leanpay/utils'

import App from 'app/app'
import {
    currentEnvironment,
    currentMarket,
    gtmId,
    isProdEnvironment,
    isStageEnvironment,
    isTestEnvironment,
} from 'library/constants'

import './index.css'

import { initI18n } from './i18n'

Sentry.init({
    dsn: 'https://135d7d83df180a36e36b4ca0436528df@o4508023659560960.ingest.de.sentry.io/4508042179641424',
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    enabled: true,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: currentEnvironment.toLowerCase(),
    ignoreErrors: [
        'Non-Error promise rejection captured with value: VENDOR_API_TOKEN_UNKNOWN',
        'Non-Error promise rejection captured with value: 502',
        'Failed to fetch dynamically imported module',
        'Network Error',
        "Can't find variable: gmo",
        'Fetch request to',
        'The object can not be cloned',
    ],
})
Sentry.setTag('market', currentMarket.toLowerCase())

if (isProdEnvironment || isStageEnvironment) {
    const tagManagerArgs = {
        gtmId,
    }

    TagManager.initialize(tagManagerArgs)
    announceStoredGoogleConsent()
}

// PostHog Analytics Configuration
const analyticsContext: AnalyticsContext = {
    app: 'pre-qualify',
    market: currentMarket,
    environment: currentEnvironment,
    apiKey: 'phc_aLiRBZwuwIC4HZ5uveu1aJE3aLkpO5jIoWIaXeJ6gGv',
    apiHost: 'https://eu.i.posthog.com',
    disabled: !isTestEnvironment,
    enableHeatmaps: true,
    hostname: window.location.hostname,
}

// Initialize i18n before rendering
initI18n().then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <LeanPayAnalyticsProvider context={analyticsContext}>
                <App />
            </LeanPayAnalyticsProvider>
        </React.StrictMode>,
    )
})
